module.exports = __webpack_public_path__ + "media/icons/mailing-twitter@2x-7983018d.png";